import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import Header from "../../reusable/Header";
import {Button} from "@nextui-org/react";
import PoweredBy from "../../reusable/PoweredBy";
import {Stepper} from "./Stepper";
import {VideoAgreementStep1} from "../../icons/VideoAgreementStep1";
import {VideoAgreementStep2} from "../../icons/VideoAgreementStep2";
import {VideoAgreementStep3} from "../../icons/VideoAgreementStep3";

const tourViews = (currentStep, t) => {
    if (currentStep === 0) {
        return (
            <div className="flex flex-col gap-10 justify-center items-center">
                <VideoAgreementStep1/>
                <div className="desc text-center">{t("videoAgreement.help.tour.step1")}</div>
            </div>
        );
    } else if (currentStep === 1) {
        return (
            <div className="flex flex-col gap-10 justify-center items-center">
                <VideoAgreementStep2/>
                <div className="desc text-center">{t("videoAgreement.help.tour.step2")}</div>
            </div>
        );
    } else if (currentStep === 2) {
        return (
            <div className="flex flex-col gap-10 justify-center items-center">
                <VideoAgreementStep3/>
                <div className="desc text-center">{t("videoAgreement.help.tour.step3")}</div>
            </div>
        );
    }

}

function VideoAgreementHelp({openCamera}) {
    const { t } = useTranslation();
    const [currentStep, setCurrentStep] = useState(0);
    const numberOfSteps = 3;

    const handleNext = () => {
        setCurrentStep((prev) => Math.min(prev + 1,  numberOfSteps));
        if(currentStep >= numberOfSteps - 1){
            openCamera(true)
        }
    }
    return (
        <div className="flex flex-col h-full">
            <Header/>
            <div className="flex flex-col p-5 h-full justify-between">

                {/* Title + Stepper grouped */}
                <div className="flex flex-col gap-4">
                    <div className="flex flex-col items-center text-center gap-1">
                        <div className="heading text-xl">{t("videoAgreement.help.heading")}</div>
                        <div className="desc text-sm" style={{color: "var(--urtentic-sdk-subtitle, #737373)"}}>{t("videoAgreement.help.subheading")}</div>
                    </div>
                    <Stepper numberOfSteps={numberOfSteps} currentStep={currentStep}>
                        {tourViews(currentStep, t)}
                    </Stepper>
                </div>

                {/* CTA */}
                <div className="flex flex-col gap-2">
                    <Button radius="sm" fullWidth color="primary" onClick={handleNext}>
                        {t("videoAgreement.help.next")}
                    </Button>
                    <PoweredBy/>
                </div>

            </div>
        </div>
    );

}

export default VideoAgreementHelp;
